export enum ToastMessageType {
  Error = 'error',
  Info = 'info',
  Success = 'success'
}